/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BannerClassStudentViewModel } from "../types/BannerClassStudentViewModel.ts";

export const bannerClassStudentViewModelSchema = z.object({
  classStudentId: z.optional(
    z
      .number()
      .int()
      .describe("ID da matrícula (ClassStudent) vinculada ao banner."),
  ),
  description: z.string().describe("Descrição da turma vinculada.").nullish(),
}) as unknown as ToZod<BannerClassStudentViewModel>;
